// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lotad: PokeData = {
  "id": 270,
  "name": "lotad",
  "height": 5,
  "weight": 26,
  "base_experience": 44,
  "types": [
    PokeType.WATER,
    PokeType.GRASS
  ],
  "api_moves": [
    "growl",
    "mist",
    "water-gun",
    "bubble-beam",
    "absorb",
    "mega-drain",
    "leech-seed",
    "bubble",
    "flail",
    "giga-drain",
    "rain-dance",
    "nature-power",
    "astonish",
    "natural-gift",
    "energy-ball",
    "zen-headbutt"
  ],
  "moves": [
    "growl",
    "bubble-beam",
    "bubble",
    "rain-dance",
    "energy-ball",
    "zen-headbutt",
    "vine-whip",
    "branch-poke",
    "aqua-cutter",
    "overgrowth",
    "leaf-tornado",
    "solar-beam",
    "grassy-terrain"
  ],
  "evolution_chain": {
    "id": 136,
    "item": null,
    "species": [
      {
        "name": "lotad",
        "order": 295,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lombre",
        "order": 296,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 270,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ludicolo",
        "order": 297,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 271,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 30,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
